import React, {useContext, useEffect, useState} from "react";
import { Link, NavLink } from "react-router-dom";
import { AuthContext } from "../App";
import "./css/homeNavBar.css";
import axios from "axios";

const HomePageNavBar = () => {
    const { token, logout } = useContext(AuthContext);
    const isLoggedIn = !!token;
    const [user, setUser] = useState(null);
    const [members, setMembers] = useState([]);

    const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/profile`;
    const API_URL2 = `${process.env.REACT_APP_BACKEND_URL}/api/members`;

    const getAuthHeaders = () => {
        const token = localStorage.getItem("FORCE_GYM_TOKEN");
        return { headers: { Authorization: `Bearer ${token}` } };
    };

    const fetchProfile = async () => {
        try {
            const res = await axios.get(API_URL, getAuthHeaders());
            setUser(res.data);
            console.log("user", user)
        } catch (err) {
            console.error(err);
        }
    };

    const fetchMembers = async () => {
        try {
            const res = await axios.get(API_URL2);
            setMembers(
                res.data.map((m) => ({
                    id: m.id,
                    fullName: m.full_name,
                    dob: m.birth_date ? m.birth_date.split('T')[0] : "",
                    age: m.age,
                    phone: m.phone,
                    password: m.password,
                    weight: m.weight,
                    height: m.height,
                    smoker: m.smoker || "لا",
                    goal: m.goal || "",
                    notes: m.health_notes || "",
                    subscription_type: m.subscription_type || "",
                    subscription_valid_until: m.subscription_valid_until || "",
                    start_date: m.start_date ? m.start_date.split('T')[0] : "",
                    profile_image: m.profile_image || null,
                }))
            );
        } catch (err) {
            console.error(err);
        }
    };


    useEffect(() => {
        console.log(user)
        console.log(members.length)
        if (user != null && members.length != 0) {
            return;
        }
        fetchProfile();
        fetchMembers();

    }, [user, members]);

    const [currentUser] = members?.filter((member) => member?.id === user?.id);
    console.log("current user", currentUser)
    const handleLogout = () => {
        logout();
        window.location.href = "/login";
    };

    return (
        <nav className="navbar navbar-expand-md navbar-dark navbar-custom" dir="rtl">
            <div className="container-fluid d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center order-1">
                    <img
                        src="/the_force_gym_logo.jpg"
                        alt="Gym Logo"
                        className="rounded-circle border"
                        style={{ width: "40px", height: "40px", marginLeft: "10px" }}
                    />
                    <span className="navbar-brand mb-0 h1">The Force Gym</span>
                </div>

                <div className="d-none d-md-flex">
                    <ul className="navbar-nav me-auto d-flex flex-row gap-3 align-items-center">
                        {!isLoggedIn ? (
                            <>
                                <li className="nav-item">
                                    <Link to="/login" className="nav-link">
                                        تسجيل الدخول
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/aboutUs" className="nav-link">
                                        نبذة عنا
                                    </Link>
                                </li>
                            </>
                        ) : (
                            <>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to="/home">
                                        الصفحة الرئيسية
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to="/profile">
                                        الملف الشخصي
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to="/change-password">
                                        تغيير كلمة المرور
                                    </NavLink>
                                </li>

                                <li className="nav-item">
                                    <NavLink className="nav-link">

                                        {currentUser && (() => {
                                            if (!currentUser?.subscription_type || !currentUser?.subscription_valid_until || currentUser?.subscription_valid_until === "null") {
                                                return <span className="badge bg-secondary">لا يوجد اشتراك</span>;
                                            }

                                            const validUntil = new Date(currentUser.subscription_valid_until);
                                            const today = new Date();
                                            validUntil.setHours(0, 0, 0, 0);
                                            today.setHours(0, 0, 0, 0);

                                            const diffDays = Math.ceil((validUntil - today) / (1000 * 60 * 60 * 24));

                                            let badgeVariant = "";
                                            let bgColor = "";
                                            let statusText = "";

                                            if (diffDays < 0) {
                                                bgColor = "#EF4444";
                                                statusText = "منتهي";
                                            } else if (diffDays <= 7) {
                                                bgColor = "#F59E0B";
                                                statusText = `متبقي ${diffDays} يوم`;
                                            } else {
                                                bgColor = "#10B981";
                                                statusText = `متبقي ${diffDays} يوم`;
                                            }

                                            return (
                                                <span style={{
                                                    backgroundColor: bgColor,
                                                    color: "white",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "14px",
                                                    display: "inline-block"
                                                }}>
                    {currentUser?.subscription_type} - {validUntil.toLocaleDateString("ar-EG")} ({statusText})
                  </span>
                                            );
                                        })()}
                                    </NavLink>
                                </li>


                                <li className="nav-item">
                                    <button
                                        onClick={handleLogout}
                                        className="btn btn-link nav-link text-danger"
                                    >
                                        تسجيل الخروج
                                    </button>
                                </li>
                            </>
                        )}
                    </ul>
                </div>

                <div className="d-md-none dropdown">
                    <button
                        className="btn btn-toggle"
                        type="button"
                        id="mobileMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        ☰
                    </button>

                    <ul
                        className="dropdown-menu dropdown-menu-end text-end"
                        aria-labelledby="mobileMenuButton"
                    >
                        {!isLoggedIn ? (
                            <>
                                <li>
                                    <Link to="/login" className="dropdown-item">
                                        تسجيل الدخول
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/aboutUs" className="dropdown-item">
                                        نبذة عنا
                                    </Link>
                                </li>
                            </>
                        ) : (
                            <>
                                <li>
                                    <NavLink to="/home" className="dropdown-item">
                                        الصفحة الرئيسية
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/profile" className="dropdown-item">
                                        الملف الشخصي
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/change-password" className="dropdown-item">
                                        تغيير كلمة المرور
                                    </NavLink>
                                </li>

                                <li className="nav-item">
                                    <NavLink className="nav-link">
                                        {currentUser && (() => {
                                            if (!currentUser.subscription_type || !currentUser.subscription_valid_until || currentUser.subscription_valid_until === "null") {
                                                return <span className="badge bg-secondary">لا يوجد اشتراك</span>;
                                            }

                                            const validUntil = new Date(currentUser.subscription_valid_until);
                                            const today = new Date();
                                            validUntil.setHours(0, 0, 0, 0);
                                            today.setHours(0, 0, 0, 0);

                                            const diffDays = Math.ceil((validUntil - today) / (1000 * 60 * 60 * 24));

                                            let badgeVariant = "";
                                            let bgColor = "";
                                            let statusText = "";

                                            if (diffDays < 0) {
                                                bgColor = "#EF4444";
                                                statusText = "منتهي";
                                            } else if (diffDays <= 7) {
                                                bgColor = "#F59E0B";
                                                statusText = `متبقي ${diffDays} يوم`;
                                            } else {
                                                bgColor = "#10B981";
                                                statusText = `متبقي ${diffDays} يوم`;
                                            }

                                            return (
                                                <span style={{
                                                    backgroundColor: bgColor,
                                                    color: "white",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "14px",
                                                    display: "inline-block"
                                                }}>
                    {currentUser.subscription_type} - {validUntil.toLocaleDateString("ar-EG")} ({statusText})
                  </span>
                                            );
                                        })()}
                                    </NavLink>
                                </li>

                                <li>
                                    <button
                                        onClick={handleLogout}
                                        className="dropdown-item text-danger"
                                    >
                                        تسجيل الخروج
                                    </button>
                                </li>
                            </>
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default HomePageNavBar;
